export default __webpack_public_path__ + "static/media/express.61a66b30.svg";